import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../_utils/storage/storage.service';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.storageService.get('user')?.token;
    if (!token) {
      return next.handle(request);
    } else {
      const modifiedRequest = request.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + token
        }
      })
      return next.handle(modifiedRequest);
    }
  }
}